import { type LeadType } from '@app/queries/lead/lead';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface LeadCoreInfoState {
  leadInfo?: Omit<LeadType, 'leadAttributeValues' | 'leadAttributeOptionValues'>;
  leadDetailsMode: 'view' | 'edit';
}

const initialState: LeadCoreInfoState = {
  leadDetailsMode: 'view',
};

export const leadCoreInfoSlice = createSlice({
  name: 'leadCoreInfo',
  initialState,
  reducers: {
    setLeadInfo: (state, action: PayloadAction<LeadType>) => {
      state.leadInfo = action.payload;
    },
    setLeadDetailsMode: (state, action: PayloadAction<'view' | 'edit'>) => {
      state.leadDetailsMode = action.payload;
    },
  },
});

export const {
  setLeadInfo,
  setLeadDetailsMode,
} = leadCoreInfoSlice.actions;

export default leadCoreInfoSlice.reducer;
